/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export const ro = {
  'date-utils': {
    errors: {
      deliveryIsBeforePickup: 'Data de predare trebuie sa fie dupa data de preluare',
      pickupEndTimeIsBeforeNow: 'Timpul final de preluare trebuie sa fie in prezent',
      pickupIsBeforeToday: 'Data de preluare trebuie sa fie in prezent',
      selectedDateAfterCurrentDatedateRange: 'Data selectata este in trecut'
    }
  }
}
